import useMethodStore, { useMethodActions } from "@/store/MethodStore"
import games from "@/data/games"
import { FaPlay } from "react-icons/fa";
import useBrowserStore from "@/store/browserStore";

function Games() {
  const {  setBrowserState, setFocusedWindow } = useMethodActions()
  const gameState = useMethodStore(state => state.gameState)
  const browserState = useMethodStore(state => state.browserState)
  const setLink = useBrowserStore(state => state.setLink)

  return (
    <div className="flex h-full w-full lg:h-full lg:w-full bg-zinc-300 dark:bg-zinc-900 overflow-y-auto scroll2 p-4">
      <div className={`h-fit w-full grid ${(gameState === "maximized") ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3" : "grid-cols-1 sm:grid-cols-2"} gap-4`}>
        {games.map(({ image, description, link, title }, index) => (
          <div key={index} className={`w-full group rounded-md`} onClick={(e) => {
            e.stopPropagation()
            if (browserState === "closed" || browserState === "minimized") setBrowserState("floating");
            setLink(link)
            setFocusedWindow("Browser")
          }}>
            <div className="relative w-fit overflow-hidden">
              <img src={image} alt={title} className={`w-full group-hover:scale-110 transition-all duration-200 ${(gameState === "maximized") ? "xl:h-72 2xl:h-80" : "xl:h-60 2xl:h-64"} object-cover`} />
              <div className="absolute flex justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 top-0 left-0 w-full h-full bg-black/60">
                <FaPlay className="text-5xl cursor-pointer" />
              </div>
            </div>
            <div className="p-2">
              <h2 className="text-lg font-semibold">{title}</h2>
              <p className="text-sm text-zinc-600 dark:text-zinc-400">{description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Games